module.exports = __webpack_public_path__ + "assets/jsdelivr.35ca248a.svg";